// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `fi-checklist-edit-checkpoint-select-role-to-notify {
  display: block;
}
fi-checklist-edit-checkpoint-select-role-to-notify .mat-mdc-form-field {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./Source/app/checklist/edit/checkpoint-select-role-to-notify/checkpoint-select-role-to-notify.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;AACJ;AACI;EACI,WAAA;AACR","sourcesContent":["fi-checklist-edit-checkpoint-select-role-to-notify {\r\n    display: block;\r\n\r\n    .mat-mdc-form-field {\r\n        width: 100%;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
